import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audio-artifact',
  templateUrl: './audio-artifact.component.html',
  styleUrls: ['./audio-artifact.component.css']
})
export class AudioArtifactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
